import { Grid, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { BsBarChartLine } from 'react-icons/bs';
import { useWeightMeasurements } from 'hooks/api/useWeightData';
import { PaperWithBorder } from 'components/PaperWithBorder';
import { DonutChart } from 'components/Charts/DonutChart/DonutChart';
import { WeightIndicator } from 'models/weight';
import { PatientDetailsDescriptionKeys } from 'models/measurement';
import { ChartLabelPrefix } from 'models/charts';
import { WeightBmiCharts } from './WeightBmiCharts';
import { WeightCalendarEvents } from './WeightCalendarEvents';
import { PatientDetailsGrid } from '../../PatientDetailsGrid';

export const WeightBmiOverview = () => {
  const { t } = useTranslation();
  const { isEnabled, isLoading, distributionValues } = useWeightMeasurements();

  return (
    <PatientDetailsGrid
      title={t('patients_tab_weight')}
      Icon={BsBarChartLine}
      pageDescriptionKey={PatientDetailsDescriptionKeys.WeightBmi}
      isEnabled={isEnabled}
    >
      <Grid.Col span={7}>
        <Stack>
          <WeightBmiCharts />
        </Stack>
      </Grid.Col>
      <Grid.Col span={5}>
        <Stack>
          <PaperWithBorder isLoading={isLoading} title={t('type_of_measurements_label')} testId={'weight-bmi-donut'}>
            <DonutChart<WeightIndicator> data={distributionValues} labelPrefix={ChartLabelPrefix.Indicator} />
          </PaperWithBorder>
        </Stack>
      </Grid.Col>
      <Grid.Col span={12}>
        <WeightCalendarEvents />
      </Grid.Col>
    </PatientDetailsGrid>
  );
};
